import React from 'react';
import { IMainProvidersProps } from './IMainProvidersProps';

const ControllerContext = React.createContext<IMainProvidersProps>(
  {} as IMainProvidersProps,
);
export const useControllerData = () => React.useContext(ControllerContext);
export const ControllerProvider = ControllerContext.Provider;
